var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 36.7637H35",
    stroke: "#CCBFDD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33329 14.064H6.66667C5.75 14.064 5 14.814 5 15.7306V30.0973C5 31.014 5.75 31.764 6.66667 31.764H9.33329C10.25 31.764 11 31.014 11 30.0973V15.7306C11 14.814 10.25 14.064 9.33329 14.064Z",
    stroke: "#CCBFDD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 8.74756H18.6667C17.75 8.74756 17 9.49756 17 10.4142V30.0976C17 31.0142 17.75 31.7642 18.6667 31.7642H21.3333C22.25 31.7642 23 31.0142 23 30.0976V10.4142C23 9.49756 22.25 8.74756 21.3333 8.74756Z",
    stroke: "#CCBFDD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3333 3.43066H30.6667C29.75 3.43066 29 4.18066 29 5.09733V30.0973C29 31.014 29.75 31.764 30.6667 31.764H33.3333C34.25 31.764 35 31.014 35 30.0973V5.09733C35 4.18066 34.25 3.43066 33.3333 3.43066Z",
    stroke: "#CCBFDD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrders);
export default __webpack_public_path__ + "static/media/orders.31e8c8a055c81b25d2c97d1ada3f4c54.svg";
export { ForwardRef as ReactComponent };